import { CseData } from './cse.types';
import Cookies from 'js-cookie';
import type { Locale, Lang } from "@/service/translate/flights/flightTranslations.types"

export function getCseData(locale: Locale): CseData | null {
    try {
        if (!isCSE(locale)) return null;
        const company = Cookies.get('company');
        const companyLang = Cookies.get('companyLang') as Lang;
        const travelerCompanions = Cookies.get('travelerCompanions');
        const companyData = Cookies.get('companyData');

        if (company && companyLang) {
            return {
                company,
                companyLang,
                travelerCompanions: travelerCompanions ? JSON.parse(travelerCompanions) : null,
                companyData: companyData ? JSON.parse(companyData) : null,
            };
        }
        return null;
    } catch (error) {
        return null;
    }

}

export const isCSE = (locale: Locale) => {
    return window.location.host.includes('cse.') || locale.includes('CSE')
}